<!-- Modernized Header -->
<div class="card shadow-3" [class.scrolled]="isScrolled">
  <p-toolbar class="responsive-toolbar">
    <div class="p-toolbar-group-start header-left">
      <!-- Logo -->
      <div class="logo-container">
        <img
          src="assets/images/logo.png"
          alt="JobWorld Logo"
          class="app-logo"
        />
      </div>
      <!-- Logo -->
      <!-- <div class="logo-text">Job<span style="color: #02508a;">World</span></div> -->

      <!-- Divider -->
      <div class="divider"></div>

      <!-- Workspace Identity -->
      <div class="user-identity" *ngIf="userName">
        <div class="user-name" [title]="userName">
          {{ userName }}
        </div>

        <div class="user-role" [title]="role | titlecase">
          {{ role | titlecase }}
        </div>
      </div>
    </div>

    <div class="p-toolbar-group-end flex items-center gap-3 nav-wrapper">
      <!-- Hamburger Icon -->
      <button
        class="hamburger-icon d-block d-md-none"
        (click)="toggleMenu()"
        *ngIf="role !== 'Candidate'"
      >
        <i class="pi pi-bars"></i>
      </button>

      <!-- Navigation Links -->
      <!-- Navigation Links -->
      <div [class.open-menu]="isMenuOpen" class="nav-items-container">
        <ng-container *ngFor="let menu of visibleMenus">
          <!-- Standard Single Nav Link -->
          <a
            *ngIf="!menu.children"
            class="nav-item"
            [routerLink]="[menu.route]"
            routerLinkActive="active"
            (click)="closeMenu()"
          >
            <i class="{{ menu.icon }} icon"></i>
            <span class="nav-label">{{ menu.label }}</span>
          </a>

          <!-- Nested Dropdown Nav Link (e.g., Practice) -->
          <div *ngIf="menu.children" class="nav-item-dropdown">
            <button class="nav-item dropdown-trigger">
              <i class="{{ menu.icon }} icon"></i>
              <span class="nav-label">{{ menu.label }}</span>
              <i class="pi pi-chevron-down dropdown-arrow"></i>
            </button>

            <!-- Submenu items -->
            <div class="dropdown-menu-panel">
              <a
                *ngFor="let child of menu.children"
                [routerLink]="[child.route]"
                [queryParams]="child.queryParams"
                routerLinkActive="active"
                class="dropdown-child-item"
                (click)="closeMenu()"
              >
                <i class="{{ child.icon }} child-icon"></i>
                <span>{{ child.label }}</span>
              </a>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Profile Avatar -->
      <div
        class="header-bar d-flex align-items-center justify-content-end gap-2"
      >
        <!-- Notification Bell (candidates only — not the org-scoped ones,
             who are here for a single exam and have no notifications) -->
        <button
          *ngIf="isCandidate && !isOrgScopedCandidate"
          type="button"
          class="notif-bell"
          aria-label="Notifications"
          (click)="goToNotifications()"
        >
          <i class="pi pi-bell"></i>

          <span class="notif-bell-badge" *ngIf="notificationCount > 0">
            {{ notificationCount > 9 ? '9+' : notificationCount }}
          </span>
        </button>

        <div
          class="wallet-chip"
          *ngIf="!isOrgScopedCandidate"
          [class.wallet-gain]="animateWallet"
          (click)="walletMenu.toggle($event)"
        >
          <div class="coin-container" *ngIf="showCoins">
            <span class="coin c1">🪙</span>
            <span class="coin c2">🪙</span>
            <span class="coin c3">🪙</span>
            <span class="coin c4">🪙</span>
            <span class="coin c5">🪙</span>

            <span class="spark s1">✨</span>
            <span class="spark s2">✨</span>
            <span class="spark s3">✨</span>
            <span class="spark s4">✨</span>
          </div>

          <div class="reward-popup" *ngIf="showReward">
            {{ rewardText }}
          </div>

          <div class="wallet-chip-icon" *ngIf="role !== 'system_admin'">
            <i class="pi pi-wallet"></i>
          </div>

          <div class="wallet-chip-content" *ngIf="role !== 'system_admin'">
            <span class="wallet-chip-label"> Credits </span>

            <span class="wallet-chip-value">
              {{ totalCredits }}
            </span>
          </div>
        </div>

        <!-- Free-trial countdown — only while organization_plan.free_tier
             is true; disappears on its own once the trial ends. -->
        <div
          class="trial-chip"
          *ngIf="showTrialCountdown"
          [class.trial-chip--calm]="trialUrgency === 'calm'"
          [class.trial-chip--amber]="trialUrgency === 'amber'"
          [class.trial-chip--red]="trialUrgency === 'red'"
          title="{{ orgPlan?.message || 'Recruitment actions are free while your organization is on trial.' }}"
        >
          <i class="pi pi-clock"></i>
          <span>{{ daysRemainingInTrial }} {{ daysRemainingInTrial === 1 ? 'day' : 'days' }} left in free trial</span>
        </div>

        <p-overlayPanel
          #walletMenu
          styleClass="wallet-overlay"
          [showCloseIcon]="false"
        >
          <div class="wallet-container">
            <div class="wallet-top">
              <div>
                <h3>My Wallet</h3>

                <p>Your learning economy</p>
              </div>

              <div class="wallet-total">
                {{ totalCredits }}
              </div>
            </div>

            <div class="credit-tile blue">
              <div class="tile-left">
                <div class="tile-icon">🔵</div>

                <div>
                  <h4>Bronze Credits</h4>

                  <small>Starter Credits</small>
                </div>
              </div>

              <span>{{ blueCredits }}</span>
            </div>

            <div class="credit-tile green">
              <div class="tile-left">
                <div class="tile-icon">🟢</div>

                <div>
                  <h4>Green Credits</h4>

                  <small>Purchased Credits</small>
                </div>
              </div>

              <span>{{ greenCredits }}</span>
            </div>

            <div class="credit-tile gold">
              <div class="tile-left">
                <div class="tile-icon">🟡</div>

                <div>
                  <h4>Gold Credits</h4>

                  <small>Rewards Earned</small>
                </div>
              </div>

              <span>{{ goldCredits }}</span>
            </div>

            <div class="wallet-footer">
              <button class="wallet-btn secondary" (click)="goToActivity()">
                Activity
              </button>

              <button class="wallet-btn primary" (click)="goToManage()">
                Manage
              </button>
            </div>
          </div>
        </p-overlayPanel>

        <!-- Candidate: Show only Logout -->
        <ng-container *ngIf="role === 'Candidate'; else profileMenu">
          <button class="p-button" (click)="logout()">
            <i class="pi pi-sign-out"></i>
          </button>
        </ng-container>

        <!-- Other Roles: Show Avatar and Full Menu -->
        <ng-template #profileMenu>
          <p-avatar
            [image]="profileImage || '../../../../assets/profile.png'"
            class="avatar"
            size="large"
            shape="circle"
            (click)="menu.toggle($event)"
          ></p-avatar>

          <p-menu #menu [model]="items" [popup]="true" appendTo="body"></p-menu>
        </ng-template>

        <!-- Theme Toggle -->
        <button
          *ngIf="role !== 'org_admin' && role !== 'hr_head' && role !== 'recruiter' && role !== 'tl' && role !== 'reporting_manager' && role !== 'system_admin'"
          type="button"
          (click)="toggleTheme()"
          class="theme-toggle header-toggle"
        >
          <div class="toggle-inner" [class.active]="isLight">
            <i class="pi pi-sun sun"></i>
            <i class="pi pi-moon moon"></i>
          </div>
        </button>
      </div>
    </div>
  </p-toolbar>
</div>
